export const TARGETS_LIMIT = 4;
